module.exports = __webpack_public_path__ + "img/sn_kitchen_b2.4c5f12a3.jpg";